﻿import Vue from "vue";
import Component from "vue-class-component";
import common from "../../common";

@Component
class SearchBoxExtensionVue extends Vue {
    bag = {} as any;
    _bagTmp: any;
    forceUpdate = '1';
    initTrigger = '';
    $initialData: any;
    preconfiguredFilters?: common.ISearchBoxPreconfiguredFilters[];
    /** Utilise afin de restaurer l'etat des sous-filtres apres un refresh via le pooler */
    currentPreconfiguredFilterStates: any;
    private _onPreconfiguredFiltersClickCallback?: (filters: common.ISearchBoxFilter[]) => void;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        this.$options.el = '#' + rootId;
        this._bagTmp = (this as any).$initialData.bag || {};

        // Preconfigured filters ========================================================================================================
        // WARNING!! la methode de sorting doit etre la meme que celle utilise dans la methode 'setPreconfiguredFilters'.
        // NOTE: Il est impossible de faire une methode avec sort car celle-ci n'existera pas encore lorsque 'beforeCreate' sera appelee.
        const sort = (x?: common.ISearchBoxPreconfiguredFilters[]) => {
            if (!x)
                return;
            x.sort((a, b) => a.order - b.order);
            for (let i = 0; i < x.length; i++) {
                const f = x[i];
                if (f.filters)
                    f.filters.sort((a, b) => a.name < b.name ? -1 : 1);
                sort(f.children);
            }
        };
        const preconfiguredFilters = (this as any).$initialData.preconfiguredFilters as common.ISearchBoxPreconfiguredFilters[] || [];
        sort(preconfiguredFilters);
        this.currentPreconfiguredFilterStates = {};
        for (let i = 0; i < preconfiguredFilters.length; i++) {
            const cf = preconfiguredFilters[i];
            cf.childrenState = common.CollapsorStates.closed;
            this.currentPreconfiguredFilterStates[cf.name] = cf.childrenState;
        }

        this.preconfiguredFilters = preconfiguredFilters;
    }

    private restorePreconfiguratedFiltersStates(filters: common.ISearchBoxPreconfiguredFilters[]) {
        for (let i = 0; i < filters.length; i++) {
            const cf = filters[i];
            const state = this.currentPreconfiguredFilterStates[cf.name] || common.CollapsorStates.closed;
            cf.childrenState = state;
        }

        return filters;
    }

    onCloseAllPreconfiguredFilterClick(event: Event) {
        this.closeAllPreconfiguredFilter();
    }

    onTogglePreconfiguredFilterChildrenStateClick(event: Event, item: common.ISearchBoxPreconfiguredFilters) {
        this.togglePreconfiguredFilterChildrenState(item);
    }
    updateBagOnInit(initTrigger: string, key: string, value?: any) {
        return this.onInit(initTrigger, () => {
            this.setToBag(key, value);
            return value;
        });
    }
    private onInit(initTrigger: string, action: () => void | string) {
        if (!initTrigger)
            return '';
        this.initTrigger = '';
        if (action)
            action();
        return action ? action() || '' : '';
    }
    /** Default state = 'closed' */
    private updatePreconfiguredFilterChildrenState(item: common.ISearchBoxPreconfiguredFilters, state?: common.CollapsorStates) {
        state = state || common.CollapsorStates.closed;
        item.childrenState = state;
        this.currentPreconfiguredFilterStates[item.name] = state;
    }

    private updatePreconfiguredFiltersChildrenState(state?: common.CollapsorStates, items?: common.ISearchBoxPreconfiguredFilters[]) {
        items = items || this.preconfiguredFilters;
        if (items)
            for (let i = 0; i < items.length; i++)
                this.updatePreconfiguredFilterChildrenState(items[i], state);
    }

    private togglePreconfiguredFilterChildrenState(item: common.ISearchBoxPreconfiguredFilters) {
        const state = item.childrenState === common.CollapsorStates.opened ? common.CollapsorStates.closed : common.CollapsorStates.opened;
        this.updatePreconfiguredFilterChildrenState(item, state);
        this.$forceUpdate();
    }

    closeAllPreconfiguredFilter(items?: common.ISearchBoxPreconfiguredFilters[]) {
        this.updatePreconfiguredFiltersChildrenState(common.CollapsorStates.closed, items);
        this.$forceUpdate();
    }

    hasOpenedPreconfiguredFilterChildren(items?: common.ISearchBoxPreconfiguredFilters[]) {
        items = items || this.preconfiguredFilters;
        if (items)
            for (let i = 0; i < items.length; i++)
                if (items[i].childrenState === common.CollapsorStates.opened)
                    return true;
        return false;
    }

    preconfiguredFilterChildrenIsOpen(item: common.ISearchBoxPreconfiguredFilters) {
        return item.childrenState === common.CollapsorStates.opened;
    }

    destroyComponents() {
    }

    created() { }

    mounted() {
        this.bag = this._bagTmp;
    }

    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === '' ? r : null;
    }

    setToBag(key: string, value: any) {
        this.$set(this.bag, key, value);
    }
    setPreconfiguredFilters(filters: common.ISearchBoxPreconfiguredFilters[]) {
        if (!filters)
            return;

        //WARNING!! la methode de sorting doit etre la meme que celle utilise dans la methode 'beforeCreate'.
        const sort = (x?: common.ISearchBoxPreconfiguredFilters[]) => {
            if (!x)
                return;
            x.sort((a, b) => a.order - b.order);
            for (let i = 0; i < x.length; i++) {
                const f = x[i];
                if (f.filters)
                    f.filters.sort((a, b) => a.name < b.name ? -1 : 1);
                sort(f.children);
            }
        };

        sort(filters);

        if (this.isDifferentPreconfiguredFilters(filters, this.preconfiguredFilters)) {
            this.preconfiguredFilters = this.restorePreconfiguratedFiltersStates(filters);
            this.$forceUpdate();
        }
    }

    private isDifferentPreconfiguredFilters(a?: common.ISearchBoxPreconfiguredFilters[], b?: common.ISearchBoxPreconfiguredFilters[]) {
        const aString = this.preconfiguredFiltersToString(a);
        const bString = this.preconfiguredFiltersToString(b);
        return aString.length !== bString.length || aString !== bString;
    }

    private preconfiguredFiltersToString(filters?: common.ISearchBoxPreconfiguredFilters[]) {
        if (!filters)
            throw "La propriete 'filters' est NULL.";
        var r = '';
        for (let i = 0; i < filters.length; i++) {
            const filter = filters[i];
            r += '___/FILTERS>_';
            //res += f.id || '';// le ID changera toujours car genere dans le backend
            r += (filter.title || 'EMPTY') + '_>_';
            r += (filter.name || 'EMPTY') + '_>_';
            r += (filter.count || 'EMPTY') + '_>_';
            r += (filter.order || 'EMPTY');

            if (filter.filters && filter.filters.length) {
                var v = '';
                for (let j = 0; j < filter.filters.length; j++) {
                    const f = filter.filters[j];
                    if (v)
                        v += '_>_';
                    v += (f.name || 'EMPTY') + '_:_';
                    v += (f.value || 'EMPTY');
                }

                if (v)
                    r += '_/VALUES>_' + v;
            }

            if (filter.children && filter.children.length)
                r += '_/CHILDREN>_' + this.preconfiguredFiltersToString(filter.children);
        }

        return r;
    }

    // private isUpdated(filter: common.ISearchBoxPreconfiguredFilters) {
    //     const get = (name: string) => {
    //         for (let i = 0; i < this.preconfiguredFilters.length; i++) {
    //             const f = this.preconfiguredFilters[i];
    //             if (f.name === name)
    //                 return f;
    //         }

    //     };
    //     const previous = get(filter.name);
    //     if (!previous)
    //         return true;
    //     if (filter.title !== previous.title)
    //         return true;
    //     if (filter.count !== previous.count)
    //         return true;
    //     if ((filter.children || null) !== (previous.children || null))
    //         return true;
    // }

    setOnPreconfiguredFiltersClickCallback(action: (filters: common.ISearchBoxFilter[]) => void) {
        this._onPreconfiguredFiltersClickCallback = action || null;
        return this;
    }

    onPreconfiguredFiltersClick(e: Event, item: common.ISearchBoxPreconfiguredFilters) {
        this.preconfiguredFiltersClick(item);
    }

    private preconfiguredFiltersClick(item: common.ISearchBoxPreconfiguredFilters) {
        if (!this._onPreconfiguredFiltersClickCallback || !item.filters)
            return;

        this._onPreconfiguredFiltersClickCallback(item.filters);
    }
}

export = SearchBoxExtensionVue;
